/* tslint:disable */
/* eslint-disable */

/**
 * deliveryProviderPortal delivery-provider-portal api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 *
 * //!!!! WARNING !!!!!!!!
 * //This is an auto generated file.
 * //Changes to this code will be lost if the code is regenerated.
 */

import { ApiResponse,  GeneratedApiClient, GeneratedHttpClientConstraints, RequestOptionsConstraint, HttpMethod, AuthStrategy, ShardingStrategy } from "../runtime";

import type {
    AuthorizationDocumentType,
    BulkDeleteMenuItems200Response,
    BulkDeleteMenuItemsRequest,
    BulkUpdateMenuEntity200Response,
    BulkUpdateMenuEntityRequest,
    BulkUploadMenuItemImagesFromCSV200Response,
    BulkUploadMenuItemImagesFromCSVRequest,
    CancelFutureMenuLinkByIdRequest,
    CancelProviderPortalOfflinePeriodRequest,
    CopyLastPublishedMenuFromVendor200Response,
    CopyLastPublishedMenuFromVendorRequest,
    CreateDineInTableRequest,
    CreateEmptyMenu200Response,
    CreateMenuEntity200Response,
    CreateMenuEntityRequest,
    CreateNewMerchantVenue200Response,
    CreateNewMerchantVenueRequestBody,
    CreateOfflinePeriod200Response,
    CreateProviderMenuTimetable200Response,
    CreateProviderMenuTimetableRequest,
    CreateProviderPortalOfflinePeriodRequest,
    CreateProviderRatingDispute200Response,
    CreateProviderRatingDisputeRequest,
    CreateRefundDispute200Response,
    CreateRefundDisputeRequest,
    DeleteChildEntityRequest,
    DeleteDineInTableRequest,
    DeleteMenuItemRequest,
    DeleteProviderMenuTimetableRequest,
    DeliveryProviderGetOrderHistoryDetails200Response,
    DineInCreateTable200Response,
    DineInGetLinkedProviderGenericQrCodes200Response,
    DineInGetQrCodeUrlForProvider200Response,
    DineInGetTablesForProvider200Response,
    DownloadProviderDraftMenusCSV200Response,
    DownloadProviderDraftMenusCSVRequest,
    DownloadProviderInvoice200Response,
    DownloadProviderInvoiceRequest,
    DownloadProviderSalesReport200Response,
    DownloadProviderSalesReportRequest,
    DownloadProviderWeeklyReportCsv200Response,
    EmptyMenuRequest,
    EnsureDraftMenuRequest,
    FeedbackSetFeedback200Response,
    FeedbackShouldGetFeedback200Response,
    FeedbackSkipFeedback200Response,
    GenerateDetailedReport200Response,
    GenerateProviderDetailedReportRequest,
    GetAvailableDynamicFields200Response,
    GetAvailableDynamicFieldsRequest,
    GetAvailableTagsForClient200Response,
    GetCampaignTagsConfig200Response,
    GetCampaignsPermissionsForProviders200Response,
    GetCampaignsPermissionsForProvidersRequestBody,
    GetDetailedReportsListForAccount200Response,
    GetDetailedReportsListForAccountRequest,
    GetDetailedReportsStatuses200Response,
    GetDetailedReportsStatusesRequest,
    GetDineInTablesForProviderRequest,
    GetDownloadLinkForDetailedReport200Response,
    GetDownloadLinkForDetailedReportRequest,
    GetDynamicFieldsValues200Response,
    GetDynamicFieldsValuesRequest,
    GetLatestOnboardingProviderForAccount200Response,
    GetLinkedProviderGenericQrCodesRequest,
    GetMainEntryWidgetUrl200Response,
    GetMenu200Response,
    GetMenuChildEntities200Response,
    GetMenuChildEntitiesRequest,
    GetMenuEditorFeatureFlags200Response,
    GetMenuEntitiesRequest,
    GetMenuEntitiesWithAgeRestrictions200Response,
    GetMenuEntity200Response,
    GetMenuEntityRequest,
    GetMenuInfo200Response,
    GetMenuInfoRequest,
    GetMenuItemsChildrenNumber200Response,
    GetMenuItemsForProviderActiveMenu200Response,
    GetMenuItemsForProviderActiveMenuRequest,
    GetMenuPreview200Response,
    GetMenuPreviewRequest,
    GetOfflinePeriods200Response,
    GetOpenImprovementTrackEnrollments200Response,
    GetOpenImprovementTrackEnrollmentsRequest,
    GetOrderHistoryDetailsRequest,
    GetOrderHistoryExtendedDetails200Response,
    GetOrderHistoryExtendedDetailsRequest,
    GetOrderHistoryPages200Response,
    GetOrderHistoryPagesRequest,
    GetOrderHistoryWithFeedbackPaginated200Response,
    GetOrderHistoryWithFeedbackPaginatedRequest,
    GetPreselectedOptionsEnablementConfig200Response,
    GetProviderAvailabilityModeList200Response,
    GetProviderAvailabilityModeListRequest,
    GetProviderBusinessRegisterOptions200Response,
    GetProviderDetails200Response,
    GetProviderInvoices200Response,
    GetProviderInvoicesRequest,
    GetProviderMenuLinks200Response,
    GetProviderMenuTimetable200Response,
    GetProviderMenuTimetables200Response,
    GetProviderMenus200Response,
    GetProviderOnboardingDetails200Response,
    GetProviderPortalOfflinePeriodsRequest,
    GetProviderSchedule200Response,
    GetProviderStatistics200Response,
    GetProviderStatisticsRequest,
    GetProviderWeeklyReport200Response,
    GetProviderWeeklyReportCsvRequest,
    GetProviderWeeklyReportList200Response,
    GetProviderWeeklyReportRequest,
    GetProvidersAIMenuTranslationsAccess200Response,
    GetProvidersAIMenuTranslationsAccessRequest,
    GetQrCodeUrlForProviderRequest,
    GetRefundDisputesPaginated200Response,
    GetShownCommissionAndFeesOptions200Response,
    GetShownCommissionAndFeesOptionsRequest,
    GetSupportCaseWidgetUrl200Response,
    GetSupportCaseWidgetUrlRequest,
    GetSupportUnreadCasesWithLastMessageRequest,
    GetSupportWidgetMqttConnectionInfo200Response,
    GetSupportWidgetMqttConnectionInfoRequest,
    GetSupportWidgetUrlRequest,
    GetTargetingValuesForProvider200Response,
    GetTargetingValuesForProviderRequest,
    GetUnreadCasesWithLastMessage200Response,
    GetVendorProviderAndMenuLinks200Response,
    GetVendorProvidersAndMenuLinksRequest,
    HideImprovementTrackEnrollmentRequest,
    IsMenuBulkUploadEnabledForProviderPortalAccount200Response,
    IsMenuModified200Response,
    LinkQrCodeToProviderAndTableRequest,
    MenuEditorBaseRequest,
    MenuEntityImageRequest,
    MenuItemsBulkUpdate200Response,
    MenuItemsBulkUpdateRequest,
    MenuItemsChildrenCountRequest,
    MenuModifiedRequest,
    OverwriteDraftMenu200Response,
    OverwriteDraftMenuRequest,
    ProviderMenuLinksRequest,
    PublishDraftMenuRequest,
    PublishMenu200Response,
    RePublishActiveMenuForProvider200Response,
    RePublishActiveMenuForProviderRequest,
    SetDynamicFieldsValuesRequest,
    SetFeedbackPortalRequest,
    ShouldGetFeedbackPortalRequest,
    SkipFeedbackPortalRequest,
    StoreImprovementTrackAnalyticsEventRequest,
    TrackDetailedReportsPageViewedRequest,
    UnlinkQrCodeToProviderAndTableRequest,
    UpdateDineInTableRequest,
    UpdateMenuEntity200Response,
    UpdateMenuEntityImage200Response,
    UpdateMenuEntityRequest,
    UpdateMenuItemsDisplayOrderRequest,
    UpdateProviderDetailsRequest,
    UpdateProviderMenuTimetableRequest,
    UpdateProviderOnboardingDetailsRequest,
    UpdateProviderScheduleRequest,
    StandardRequest,
} from '../models/index';

export interface HttpClientConstraints {
    Auth: AuthStrategy.JWT;
    Sharding: ShardingStrategy.NONE;
    StandardRequest: StandardRequest;
}

export interface GetMenuRequest {
    provider_id: number;
}
export interface GetProviderDetailsRequest {
    provider_id: number;
}
export interface GetProviderMenuTimetableRequest {
    provider_id: number;
    timetable_id: number;
}
export interface GetProviderMenuTimetablesRequest {
    provider_id: number;
}
export interface GetProviderOnboardingDetailsRequest {
    provider_id: number;
}
export interface GetProviderScheduleRequest {
    provider_id: number;
}
export interface GetRefundDisputesPaginatedRequest {
    provider_id: number;
    requested_start_timestamp: number;
    requested_end_timestamp: number;
    page?: number;
    items_per_page: number;
}
export interface UpdateMenuEntityImageMultipart {
    provider_id?: number;
    entity_id?: string;
    menu_id?: string;
}
export interface UploadProviderAuthorizationDocumentMultipart {
    provider_id: number;
    document_type?: AuthorizationDocumentType;
}
export interface UploadProviderImageMultipart {
    provider_id: number;
}


class ApiClientClass<THttpClientConstraints extends GeneratedHttpClientConstraints = HttpClientConstraints, TRequestOptions extends RequestOptionsConstraint = never> extends GeneratedApiClient<THttpClientConstraints, TRequestOptions> {
        public bulkDeleteMenuItems = async (body: BulkDeleteMenuItemsRequest, opts?: TRequestOptions): Promise<ApiResponse<BulkDeleteMenuItems200Response>>  => {
            return this.httpClient.sendRequest<ApiResponse<BulkDeleteMenuItems200Response>>({
                path: '/deliveryProviderPortal/bulkDeleteMenuItems',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public bulkUpdateMenuEntity = async (body: BulkUpdateMenuEntityRequest, opts?: TRequestOptions): Promise<ApiResponse<BulkUpdateMenuEntity200Response>>  => {
            return this.httpClient.sendRequest<ApiResponse<BulkUpdateMenuEntity200Response>>({
                path: '/deliveryProviderPortal/bulkUpdateMenuEntity',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public bulkUploadMenuItemImagesFromCSV = async (body: BulkUploadMenuItemImagesFromCSVRequest, opts?: TRequestOptions): Promise<ApiResponse<BulkUploadMenuItemImagesFromCSV200Response>>  => {
            return this.httpClient.sendRequest<ApiResponse<BulkUploadMenuItemImagesFromCSV200Response>>({
                path: '/deliveryProviderPortal/bulkUploadMenuItemImagesFromCSV',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public cancelFutureMenuLinkById = async (body: CancelFutureMenuLinkByIdRequest, opts?: TRequestOptions): Promise<ApiResponse<MenuItemsBulkUpdate200Response>>  => {
            return this.httpClient.sendRequest<ApiResponse<MenuItemsBulkUpdate200Response>>({
                path: '/deliveryProviderPortal/cancelFutureMenuLinkById',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public cancelOfflinePeriod = async (body: CancelProviderPortalOfflinePeriodRequest, opts?: TRequestOptions): Promise<ApiResponse<MenuItemsBulkUpdate200Response>>  => {
            return this.httpClient.sendRequest<ApiResponse<MenuItemsBulkUpdate200Response>>({
                path: '/deliveryProviderPortal/cancelOfflinePeriod',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public copyLastPublishedMenuFromVendor = async (body: CopyLastPublishedMenuFromVendorRequest, opts?: TRequestOptions): Promise<ApiResponse<CopyLastPublishedMenuFromVendor200Response>>  => {
            return this.httpClient.sendRequest<ApiResponse<CopyLastPublishedMenuFromVendor200Response>>({
                path: '/deliveryProviderPortal/copyLastPublishedMenuFromVendor',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public createEmptyMenu = async (body: EmptyMenuRequest, opts?: TRequestOptions): Promise<ApiResponse<CreateEmptyMenu200Response>>  => {
            return this.httpClient.sendRequest<ApiResponse<CreateEmptyMenu200Response>>({
                path: '/deliveryProviderPortal/createEmptyMenu',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public createMenuEntity = async (body: CreateMenuEntityRequest, opts?: TRequestOptions): Promise<ApiResponse<CreateMenuEntity200Response>>  => {
            return this.httpClient.sendRequest<ApiResponse<CreateMenuEntity200Response>>({
                path: '/deliveryProviderPortal/createMenuEntity',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public createNewMerchantVenue = async (body: CreateNewMerchantVenueRequestBody, opts?: TRequestOptions): Promise<ApiResponse<CreateNewMerchantVenue200Response>>  => {
            return this.httpClient.sendRequest<ApiResponse<CreateNewMerchantVenue200Response>>({
                path: '/deliveryProviderPortal/createNewMerchantVenue',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public createOfflinePeriod = async (body: CreateProviderPortalOfflinePeriodRequest, opts?: TRequestOptions): Promise<ApiResponse<CreateOfflinePeriod200Response>>  => {
            return this.httpClient.sendRequest<ApiResponse<CreateOfflinePeriod200Response>>({
                path: '/deliveryProviderPortal/createOfflinePeriod',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public createProviderMenuTimetable = async (body: CreateProviderMenuTimetableRequest, opts?: TRequestOptions): Promise<ApiResponse<CreateProviderMenuTimetable200Response>>  => {
            return this.httpClient.sendRequest<ApiResponse<CreateProviderMenuTimetable200Response>>({
                path: '/deliveryProviderPortal/createProviderMenuTimetable',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public createProviderRatingDispute = async (body: CreateProviderRatingDisputeRequest, opts?: TRequestOptions): Promise<ApiResponse<CreateProviderRatingDispute200Response>>  => {
            return this.httpClient.sendRequest<ApiResponse<CreateProviderRatingDispute200Response>>({
                path: '/deliveryProviderPortal/createProviderRatingDispute',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public createRefundDispute = async (body: CreateRefundDisputeRequest, opts?: TRequestOptions): Promise<ApiResponse<CreateRefundDispute200Response>>  => {
            return this.httpClient.sendRequest<ApiResponse<CreateRefundDispute200Response>>({
                path: '/deliveryProviderPortal/createRefundDispute',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public deleteChildEntity = async (body: DeleteChildEntityRequest, opts?: TRequestOptions): Promise<ApiResponse<MenuItemsBulkUpdate200Response>>  => {
            return this.httpClient.sendRequest<ApiResponse<MenuItemsBulkUpdate200Response>>({
                path: '/deliveryProviderPortal/deleteChildEntity',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public deleteMenuEntityImages = async (body: MenuEntityImageRequest, opts?: TRequestOptions): Promise<ApiResponse<MenuItemsBulkUpdate200Response>>  => {
            return this.httpClient.sendRequest<ApiResponse<MenuItemsBulkUpdate200Response>>({
                path: '/deliveryProviderPortal/deleteMenuEntityImages',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public deleteMenuItem = async (body: DeleteMenuItemRequest, opts?: TRequestOptions): Promise<ApiResponse<MenuItemsBulkUpdate200Response>>  => {
            return this.httpClient.sendRequest<ApiResponse<MenuItemsBulkUpdate200Response>>({
                path: '/deliveryProviderPortal/deleteMenuItem',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public deleteProviderMenuTimetable = async (body: DeleteProviderMenuTimetableRequest, opts?: TRequestOptions): Promise<ApiResponse<MenuItemsBulkUpdate200Response>>  => {
            return this.httpClient.sendRequest<ApiResponse<MenuItemsBulkUpdate200Response>>({
                path: '/deliveryProviderPortal/deleteProviderMenuTimetable',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public deliveryProviderGetOrderHistoryDetails = async (body: GetOrderHistoryDetailsRequest, opts?: TRequestOptions): Promise<ApiResponse<DeliveryProviderGetOrderHistoryDetails200Response>>  => {
            return this.httpClient.sendRequest<ApiResponse<DeliveryProviderGetOrderHistoryDetails200Response>>({
                path: '/deliveryProvider/getOrderHistoryDetails',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public dineInCreateTable = async (body: CreateDineInTableRequest, opts?: TRequestOptions): Promise<ApiResponse<DineInCreateTable200Response>>  => {
            return this.httpClient.sendRequest<ApiResponse<DineInCreateTable200Response>>({
                path: '/deliveryProviderPortal/dineIn/createTable',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public dineInDeleteTable = async (body: DeleteDineInTableRequest, opts?: TRequestOptions): Promise<ApiResponse<MenuItemsBulkUpdate200Response>>  => {
            return this.httpClient.sendRequest<ApiResponse<MenuItemsBulkUpdate200Response>>({
                path: '/deliveryProviderPortal/dineIn/deleteTable',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public dineInGetLinkedProviderGenericQrCodes = async (body: GetLinkedProviderGenericQrCodesRequest, opts?: TRequestOptions): Promise<ApiResponse<DineInGetLinkedProviderGenericQrCodes200Response>>  => {
            return this.httpClient.sendRequest<ApiResponse<DineInGetLinkedProviderGenericQrCodes200Response>>({
                path: '/deliveryProviderPortal/dineIn/getLinkedProviderGenericQrCodes',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public dineInGetQrCodeUrlForProvider = async (body: GetQrCodeUrlForProviderRequest, opts?: TRequestOptions): Promise<ApiResponse<DineInGetQrCodeUrlForProvider200Response>>  => {
            return this.httpClient.sendRequest<ApiResponse<DineInGetQrCodeUrlForProvider200Response>>({
                path: '/deliveryProviderPortal/dineIn/getQrCodeUrlForProvider',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public dineInGetTablesForProvider = async (body: GetDineInTablesForProviderRequest, opts?: TRequestOptions): Promise<ApiResponse<DineInGetTablesForProvider200Response>>  => {
            return this.httpClient.sendRequest<ApiResponse<DineInGetTablesForProvider200Response>>({
                path: '/deliveryProviderPortal/dineIn/getTablesForProvider',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public dineInLinkQrCodeToProviderAndTable = async (body: LinkQrCodeToProviderAndTableRequest, opts?: TRequestOptions): Promise<ApiResponse<MenuItemsBulkUpdate200Response>>  => {
            return this.httpClient.sendRequest<ApiResponse<MenuItemsBulkUpdate200Response>>({
                path: '/deliveryProviderPortal/dineIn/linkQrCodeToProviderAndTable',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public dineInUnlinkQrCodeToProviderAndTable = async (body: UnlinkQrCodeToProviderAndTableRequest, opts?: TRequestOptions): Promise<ApiResponse<MenuItemsBulkUpdate200Response>>  => {
            return this.httpClient.sendRequest<ApiResponse<MenuItemsBulkUpdate200Response>>({
                path: '/deliveryProviderPortal/dineIn/unlinkQrCodeToProviderAndTable',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public dineInUpdateTable = async (body: UpdateDineInTableRequest, opts?: TRequestOptions): Promise<ApiResponse<MenuItemsBulkUpdate200Response>>  => {
            return this.httpClient.sendRequest<ApiResponse<MenuItemsBulkUpdate200Response>>({
                path: '/deliveryProviderPortal/dineIn/updateTable',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public downloadProviderDraftMenusCSV = async (body: DownloadProviderDraftMenusCSVRequest, opts?: TRequestOptions): Promise<ApiResponse<DownloadProviderDraftMenusCSV200Response>>  => {
            return this.httpClient.sendRequest<ApiResponse<DownloadProviderDraftMenusCSV200Response>>({
                path: '/deliveryProviderPortal/downloadProviderDraftMenusCSV',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public downloadProviderInvoice = async (body: DownloadProviderInvoiceRequest, opts?: TRequestOptions): Promise<ApiResponse<DownloadProviderInvoice200Response>>  => {
            return this.httpClient.sendRequest<ApiResponse<DownloadProviderInvoice200Response>>({
                path: '/deliveryProviderPortal/downloadProviderInvoice',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public downloadProviderSalesReport = async (body: DownloadProviderSalesReportRequest, opts?: TRequestOptions): Promise<ApiResponse<DownloadProviderSalesReport200Response>>  => {
            return this.httpClient.sendRequest<ApiResponse<DownloadProviderSalesReport200Response>>({
                path: '/deliveryProviderPortal/downloadProviderSalesReport',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public downloadProviderWeeklyReportCsv = async (body: GetProviderWeeklyReportCsvRequest, opts?: TRequestOptions): Promise<ApiResponse<DownloadProviderWeeklyReportCsv200Response>>  => {
            return this.httpClient.sendRequest<ApiResponse<DownloadProviderWeeklyReportCsv200Response>>({
                path: '/deliveryProviderPortal/downloadProviderWeeklyReportCsv',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public ensureDraftMenu = async (body: EnsureDraftMenuRequest, opts?: TRequestOptions): Promise<ApiResponse<MenuItemsBulkUpdate200Response>>  => {
            return this.httpClient.sendRequest<ApiResponse<MenuItemsBulkUpdate200Response>>({
                path: '/deliveryProviderPortal/ensureDraftMenu',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public feedbackSetFeedback = async (body: SetFeedbackPortalRequest, opts?: TRequestOptions): Promise<ApiResponse<FeedbackSetFeedback200Response>>  => {
            return this.httpClient.sendRequest<ApiResponse<FeedbackSetFeedback200Response>>({
                path: '/deliveryProviderPortal/feedback/setFeedback',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public feedbackShouldGetFeedback = async (body: ShouldGetFeedbackPortalRequest, opts?: TRequestOptions): Promise<ApiResponse<FeedbackShouldGetFeedback200Response>>  => {
            return this.httpClient.sendRequest<ApiResponse<FeedbackShouldGetFeedback200Response>>({
                path: '/deliveryProviderPortal/feedback/shouldGetFeedback',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public feedbackSkipFeedback = async (body: SkipFeedbackPortalRequest, opts?: TRequestOptions): Promise<ApiResponse<FeedbackSkipFeedback200Response>>  => {
            return this.httpClient.sendRequest<ApiResponse<FeedbackSkipFeedback200Response>>({
                path: '/deliveryProviderPortal/feedback/skipFeedback',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public generateDetailedReport = async (body: GenerateProviderDetailedReportRequest, opts?: TRequestOptions): Promise<ApiResponse<GenerateDetailedReport200Response>>  => {
            return this.httpClient.sendRequest<ApiResponse<GenerateDetailedReport200Response>>({
                path: '/deliveryProviderPortal/generateDetailedReport',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public getAvailableDynamicFields = async (body: GetAvailableDynamicFieldsRequest, opts?: TRequestOptions): Promise<ApiResponse<GetAvailableDynamicFields200Response>>  => {
            return this.httpClient.sendRequest<ApiResponse<GetAvailableDynamicFields200Response>>({
                path: '/deliveryProviderPortal/getAvailableDynamicFields',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public getAvailableTagsForClient = async (body: MenuEditorBaseRequest, opts?: TRequestOptions): Promise<ApiResponse<GetAvailableTagsForClient200Response>>  => {
            return this.httpClient.sendRequest<ApiResponse<GetAvailableTagsForClient200Response>>({
                path: '/deliveryProviderPortal/getAvailableTagsForClient',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public getCampaignTagsConfig = async (opts?: TRequestOptions): Promise<ApiResponse<GetCampaignTagsConfig200Response>>  => {
            return this.httpClient.sendRequest<ApiResponse<GetCampaignTagsConfig200Response>>({
                path: '/deliveryProviderPortal/getCampaignTagsConfig',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.GET,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
            }, opts);
        }
        public getCampaignsPermissionsForProviders = async (body: GetCampaignsPermissionsForProvidersRequestBody, opts?: TRequestOptions): Promise<ApiResponse<GetCampaignsPermissionsForProviders200Response>>  => {
            return this.httpClient.sendRequest<ApiResponse<GetCampaignsPermissionsForProviders200Response>>({
                path: '/deliveryProviderPortal/getCampaignsPermissionsForProviders',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public getDetailedReportsListForAccount = async (body: GetDetailedReportsListForAccountRequest, opts?: TRequestOptions): Promise<ApiResponse<GetDetailedReportsListForAccount200Response>>  => {
            return this.httpClient.sendRequest<ApiResponse<GetDetailedReportsListForAccount200Response>>({
                path: '/deliveryProviderPortal/getDetailedReportsListForAccount',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public getDetailedReportsStatuses = async (body: GetDetailedReportsStatusesRequest, opts?: TRequestOptions): Promise<ApiResponse<GetDetailedReportsStatuses200Response>>  => {
            return this.httpClient.sendRequest<ApiResponse<GetDetailedReportsStatuses200Response>>({
                path: '/deliveryProviderPortal/getDetailedReportsStatuses',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public getDownloadLinkForDetailedReport = async (body: GetDownloadLinkForDetailedReportRequest, opts?: TRequestOptions): Promise<ApiResponse<GetDownloadLinkForDetailedReport200Response>>  => {
            return this.httpClient.sendRequest<ApiResponse<GetDownloadLinkForDetailedReport200Response>>({
                path: '/deliveryProviderPortal/getDownloadLinkForDetailedReport',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public getDynamicFieldsValues = async (body: GetDynamicFieldsValuesRequest, opts?: TRequestOptions): Promise<ApiResponse<GetDynamicFieldsValues200Response>>  => {
            return this.httpClient.sendRequest<ApiResponse<GetDynamicFieldsValues200Response>>({
                path: '/deliveryProviderPortal/getDynamicFieldsValues',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public getLatestOnboardingProviderForAccount = async (opts?: TRequestOptions): Promise<ApiResponse<GetLatestOnboardingProviderForAccount200Response>>  => {
            return this.httpClient.sendRequest<ApiResponse<GetLatestOnboardingProviderForAccount200Response>>({
                path: '/deliveryProviderPortal/getLatestOnboardingProviderForAccount',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.GET,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
            }, opts);
        }
        public getMainEntryWidgetUrl = async (body: GetSupportWidgetUrlRequest, opts?: TRequestOptions): Promise<ApiResponse<GetMainEntryWidgetUrl200Response>>  => {
            return this.httpClient.sendRequest<ApiResponse<GetMainEntryWidgetUrl200Response>>({
                path: '/deliveryProviderPortal/getMainEntryWidgetUrl',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public getMenu = async (query: GetMenuRequest, opts?: TRequestOptions): Promise<ApiResponse<GetMenu200Response>>  => {
            return this.httpClient.sendRequest<ApiResponse<GetMenu200Response>>({
                path: '/deliveryProviderPortal/getMenu',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.GET,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                query,
            }, opts);
        }
        public getMenuChildEntities = async (body: GetMenuChildEntitiesRequest, opts?: TRequestOptions): Promise<ApiResponse<GetMenuChildEntities200Response>>  => {
            return this.httpClient.sendRequest<ApiResponse<GetMenuChildEntities200Response>>({
                path: '/deliveryProviderPortal/getMenuChildEntities',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public getMenuEditorFeatureFlags = async (opts?: TRequestOptions): Promise<ApiResponse<GetMenuEditorFeatureFlags200Response>>  => {
            return this.httpClient.sendRequest<ApiResponse<GetMenuEditorFeatureFlags200Response>>({
                path: '/deliveryProviderPortal/getMenuEditorFeatureFlags',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
            }, opts);
        }
        public getMenuEntities = async (body: GetMenuEntitiesRequest, opts?: TRequestOptions): Promise<ApiResponse<GetMenuChildEntities200Response>>  => {
            return this.httpClient.sendRequest<ApiResponse<GetMenuChildEntities200Response>>({
                path: '/deliveryProviderPortal/getMenuEntities',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public getMenuEntitiesWithAgeRestrictions = async (body: GetMenuEntitiesRequest, opts?: TRequestOptions): Promise<ApiResponse<GetMenuEntitiesWithAgeRestrictions200Response>>  => {
            return this.httpClient.sendRequest<ApiResponse<GetMenuEntitiesWithAgeRestrictions200Response>>({
                path: '/deliveryProviderPortal/getMenuEntitiesWithAgeRestrictions',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public getMenuEntity = async (body: GetMenuEntityRequest, opts?: TRequestOptions): Promise<ApiResponse<GetMenuEntity200Response>>  => {
            return this.httpClient.sendRequest<ApiResponse<GetMenuEntity200Response>>({
                path: '/deliveryProviderPortal/getMenuEntity',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public getMenuInfo = async (body: GetMenuInfoRequest, opts?: TRequestOptions): Promise<ApiResponse<GetMenuInfo200Response>>  => {
            return this.httpClient.sendRequest<ApiResponse<GetMenuInfo200Response>>({
                path: '/deliveryProviderPortal/getMenuInfo',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public getMenuItemsChildrenNumber = async (body: MenuItemsChildrenCountRequest, opts?: TRequestOptions): Promise<ApiResponse<GetMenuItemsChildrenNumber200Response>>  => {
            return this.httpClient.sendRequest<ApiResponse<GetMenuItemsChildrenNumber200Response>>({
                path: '/deliveryProviderPortal/getMenuItemsChildrenNumber',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public getMenuItemsForProviderActiveMenu = async (body: GetMenuItemsForProviderActiveMenuRequest, opts?: TRequestOptions): Promise<ApiResponse<GetMenuItemsForProviderActiveMenu200Response>>  => {
            return this.httpClient.sendRequest<ApiResponse<GetMenuItemsForProviderActiveMenu200Response>>({
                path: '/deliveryProviderPortal/getMenuItemsForProviderActiveMenu',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public getMenuPreview = async (body: GetMenuPreviewRequest, opts?: TRequestOptions): Promise<ApiResponse<GetMenuPreview200Response>>  => {
            return this.httpClient.sendRequest<ApiResponse<GetMenuPreview200Response>>({
                path: '/deliveryProviderPortal/getMenuPreview',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public getOfflinePeriods = async (body: GetProviderPortalOfflinePeriodsRequest, opts?: TRequestOptions): Promise<ApiResponse<GetOfflinePeriods200Response>>  => {
            return this.httpClient.sendRequest<ApiResponse<GetOfflinePeriods200Response>>({
                path: '/deliveryProviderPortal/getOfflinePeriods',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public getOpenImprovementTrackEnrollments = async (body: GetOpenImprovementTrackEnrollmentsRequest, opts?: TRequestOptions): Promise<ApiResponse<GetOpenImprovementTrackEnrollments200Response>>  => {
            return this.httpClient.sendRequest<ApiResponse<GetOpenImprovementTrackEnrollments200Response>>({
                path: '/deliveryProviderPortal/getOpenImprovementTrackEnrollments',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public getOrderHistoryExtendedDetails = async (body: GetOrderHistoryExtendedDetailsRequest, opts?: TRequestOptions): Promise<ApiResponse<GetOrderHistoryExtendedDetails200Response>>  => {
            return this.httpClient.sendRequest<ApiResponse<GetOrderHistoryExtendedDetails200Response>>({
                path: '/deliveryProviderPortal/getOrderHistoryExtendedDetails',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public getOrderHistoryPages = async (body: GetOrderHistoryPagesRequest, opts?: TRequestOptions): Promise<ApiResponse<GetOrderHistoryPages200Response>>  => {
            return this.httpClient.sendRequest<ApiResponse<GetOrderHistoryPages200Response>>({
                path: '/deliveryProviderPortal/getOrderHistoryPages',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public getOrderHistoryWithFeedbackPaginated = async (body: GetOrderHistoryWithFeedbackPaginatedRequest, opts?: TRequestOptions): Promise<ApiResponse<GetOrderHistoryWithFeedbackPaginated200Response>>  => {
            return this.httpClient.sendRequest<ApiResponse<GetOrderHistoryWithFeedbackPaginated200Response>>({
                path: '/deliveryProviderPortal/getOrderHistoryWithFeedbackPaginated',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public getPreselectedOptionsEnablementConfig = async (opts?: TRequestOptions): Promise<ApiResponse<GetPreselectedOptionsEnablementConfig200Response>>  => {
            return this.httpClient.sendRequest<ApiResponse<GetPreselectedOptionsEnablementConfig200Response>>({
                path: '/deliveryProviderPortal/getPreselectedOptionsEnablementConfig',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.GET,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
            }, opts);
        }
        public getProviderAvailabilityModeList = async (body: GetProviderAvailabilityModeListRequest, opts?: TRequestOptions): Promise<ApiResponse<GetProviderAvailabilityModeList200Response>>  => {
            return this.httpClient.sendRequest<ApiResponse<GetProviderAvailabilityModeList200Response>>({
                path: '/deliveryProviderPortal/getProviderAvailabilityModeList',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public getProviderBusinessRegisterOptions = async (opts?: TRequestOptions): Promise<ApiResponse<GetProviderBusinessRegisterOptions200Response>>  => {
            return this.httpClient.sendRequest<ApiResponse<GetProviderBusinessRegisterOptions200Response>>({
                path: '/deliveryProviderPortal/getProviderBusinessRegisterOptions',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.GET,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
            }, opts);
        }
        public getProviderDetails = async (query: GetProviderDetailsRequest, opts?: TRequestOptions): Promise<ApiResponse<GetProviderDetails200Response>>  => {
            return this.httpClient.sendRequest<ApiResponse<GetProviderDetails200Response>>({
                path: '/deliveryProviderPortal/getProviderDetails',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.GET,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                query,
            }, opts);
        }
        public getProviderInvoices = async (body: GetProviderInvoicesRequest, opts?: TRequestOptions): Promise<ApiResponse<GetProviderInvoices200Response>>  => {
            return this.httpClient.sendRequest<ApiResponse<GetProviderInvoices200Response>>({
                path: '/deliveryProviderPortal/getProviderInvoices',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public getProviderMenuLinks = async (body: ProviderMenuLinksRequest, opts?: TRequestOptions): Promise<ApiResponse<GetProviderMenuLinks200Response>>  => {
            return this.httpClient.sendRequest<ApiResponse<GetProviderMenuLinks200Response>>({
                path: '/deliveryProviderPortal/getProviderMenuLinks',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public getProviderMenuTimetable = async (query: GetProviderMenuTimetableRequest, opts?: TRequestOptions): Promise<ApiResponse<GetProviderMenuTimetable200Response>>  => {
            return this.httpClient.sendRequest<ApiResponse<GetProviderMenuTimetable200Response>>({
                path: '/deliveryProviderPortal/getProviderMenuTimetable',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.GET,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                query,
            }, opts);
        }
        public getProviderMenuTimetables = async (query: GetProviderMenuTimetablesRequest, opts?: TRequestOptions): Promise<ApiResponse<GetProviderMenuTimetables200Response>>  => {
            return this.httpClient.sendRequest<ApiResponse<GetProviderMenuTimetables200Response>>({
                path: '/deliveryProviderPortal/getProviderMenuTimetables',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.GET,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                query,
            }, opts);
        }
        public getProviderMenus = async (body: MenuEditorBaseRequest, opts?: TRequestOptions): Promise<ApiResponse<GetProviderMenus200Response>>  => {
            return this.httpClient.sendRequest<ApiResponse<GetProviderMenus200Response>>({
                path: '/deliveryProviderPortal/getProviderMenus',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public getProviderOnboardingDetails = async (query: GetProviderOnboardingDetailsRequest, opts?: TRequestOptions): Promise<ApiResponse<GetProviderOnboardingDetails200Response>>  => {
            return this.httpClient.sendRequest<ApiResponse<GetProviderOnboardingDetails200Response>>({
                path: '/deliveryProviderPortal/getProviderOnboardingDetails',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.GET,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                query,
            }, opts);
        }
        public getProviderSchedule = async (query: GetProviderScheduleRequest, opts?: TRequestOptions): Promise<ApiResponse<GetProviderSchedule200Response>>  => {
            return this.httpClient.sendRequest<ApiResponse<GetProviderSchedule200Response>>({
                path: '/deliveryProviderPortal/getProviderSchedule',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.GET,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                query,
            }, opts);
        }
        public getProviderStatistics = async (body: GetProviderStatisticsRequest, opts?: TRequestOptions): Promise<ApiResponse<GetProviderStatistics200Response>>  => {
            return this.httpClient.sendRequest<ApiResponse<GetProviderStatistics200Response>>({
                path: '/deliveryProviderPortal/getProviderStatistics',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public getProviderWeeklyReport = async (body: GetProviderWeeklyReportRequest, opts?: TRequestOptions): Promise<ApiResponse<GetProviderWeeklyReport200Response>>  => {
            return this.httpClient.sendRequest<ApiResponse<GetProviderWeeklyReport200Response>>({
                path: '/deliveryProviderPortal/getProviderWeeklyReport',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public getProviderWeeklyReportList = async (body: object, opts?: TRequestOptions): Promise<ApiResponse<GetProviderWeeklyReportList200Response>>  => {
            return this.httpClient.sendRequest<ApiResponse<GetProviderWeeklyReportList200Response>>({
                path: '/deliveryProviderPortal/getProviderWeeklyReportList',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public getProvidersAIMenuTranslationsAccess = async (body: GetProvidersAIMenuTranslationsAccessRequest, opts?: TRequestOptions): Promise<ApiResponse<GetProvidersAIMenuTranslationsAccess200Response>>  => {
            return this.httpClient.sendRequest<ApiResponse<GetProvidersAIMenuTranslationsAccess200Response>>({
                path: '/deliveryProviderPortal/getProvidersAIMenuTranslationsAccess',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public getRefundDisputesPaginated = async (query: GetRefundDisputesPaginatedRequest, opts?: TRequestOptions): Promise<ApiResponse<GetRefundDisputesPaginated200Response>>  => {
            return this.httpClient.sendRequest<ApiResponse<GetRefundDisputesPaginated200Response>>({
                path: '/deliveryProviderPortal/getRefundDisputesPaginated',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.GET,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                query,
            }, opts);
        }
        public getShownCommissionAndFeesOptions = async (body: GetShownCommissionAndFeesOptionsRequest, opts?: TRequestOptions): Promise<ApiResponse<GetShownCommissionAndFeesOptions200Response>>  => {
            return this.httpClient.sendRequest<ApiResponse<GetShownCommissionAndFeesOptions200Response>>({
                path: '/deliveryProviderPortal/getShownCommissionAndFeesOptions',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public getSupportCaseWidgetUrl = async (body: GetSupportCaseWidgetUrlRequest, opts?: TRequestOptions): Promise<ApiResponse<GetSupportCaseWidgetUrl200Response>>  => {
            return this.httpClient.sendRequest<ApiResponse<GetSupportCaseWidgetUrl200Response>>({
                path: '/deliveryProviderPortal/getSupportCaseWidgetUrl',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public getSupportWidgetMqttConnectionInfo = async (body: GetSupportWidgetMqttConnectionInfoRequest, opts?: TRequestOptions): Promise<ApiResponse<GetSupportWidgetMqttConnectionInfo200Response>>  => {
            return this.httpClient.sendRequest<ApiResponse<GetSupportWidgetMqttConnectionInfo200Response>>({
                path: '/deliveryProviderPortal/getSupportWidgetMqttConnectionInfo',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public getTargetingValuesForProvider = async (body: GetTargetingValuesForProviderRequest, opts?: TRequestOptions): Promise<ApiResponse<GetTargetingValuesForProvider200Response>>  => {
            return this.httpClient.sendRequest<ApiResponse<GetTargetingValuesForProvider200Response>>({
                path: '/deliveryProviderPortal/getTargetingValuesForProvider',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public getUnreadCasesWithLastMessage = async (body: GetSupportUnreadCasesWithLastMessageRequest, opts?: TRequestOptions): Promise<ApiResponse<GetUnreadCasesWithLastMessage200Response>>  => {
            return this.httpClient.sendRequest<ApiResponse<GetUnreadCasesWithLastMessage200Response>>({
                path: '/deliveryProviderPortal/getUnreadCasesWithLastMessage',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public getVendorProviderAndMenuLinks = async (body: GetVendorProvidersAndMenuLinksRequest, opts?: TRequestOptions): Promise<ApiResponse<GetVendorProviderAndMenuLinks200Response>>  => {
            return this.httpClient.sendRequest<ApiResponse<GetVendorProviderAndMenuLinks200Response>>({
                path: '/deliveryProviderPortal/getVendorProviderAndMenuLinks',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public hideImprovementTrackEnrollment = async (body: HideImprovementTrackEnrollmentRequest, opts?: TRequestOptions): Promise<ApiResponse<MenuItemsBulkUpdate200Response>>  => {
            return this.httpClient.sendRequest<ApiResponse<MenuItemsBulkUpdate200Response>>({
                path: '/deliveryProviderPortal/hideImprovementTrackEnrollment',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public isMenuBulkUploadEnabledForProviderPortalAccount = async (opts?: TRequestOptions): Promise<ApiResponse<IsMenuBulkUploadEnabledForProviderPortalAccount200Response>>  => {
            return this.httpClient.sendRequest<ApiResponse<IsMenuBulkUploadEnabledForProviderPortalAccount200Response>>({
                path: '/deliveryProviderPortal/isMenuBulkUploadEnabledForProviderPortalAccount',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.GET,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
            }, opts);
        }
        public isMenuModified = async (body: MenuModifiedRequest, opts?: TRequestOptions): Promise<ApiResponse<IsMenuModified200Response>>  => {
            return this.httpClient.sendRequest<ApiResponse<IsMenuModified200Response>>({
                path: '/deliveryProviderPortal/isMenuModified',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public menuItemsBulkUpdate = async (body: MenuItemsBulkUpdateRequest, opts?: TRequestOptions): Promise<ApiResponse<MenuItemsBulkUpdate200Response>>  => {
            return this.httpClient.sendRequest<ApiResponse<MenuItemsBulkUpdate200Response>>({
                path: '/deliveryProviderPortal/menuItemsBulkUpdate',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public overwriteDraftMenu = async (body: OverwriteDraftMenuRequest, opts?: TRequestOptions): Promise<ApiResponse<OverwriteDraftMenu200Response>>  => {
            return this.httpClient.sendRequest<ApiResponse<OverwriteDraftMenu200Response>>({
                path: '/deliveryProviderPortal/overwriteDraftMenu',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public publishMenu = async (body: PublishDraftMenuRequest, opts?: TRequestOptions): Promise<ApiResponse<PublishMenu200Response>>  => {
            return this.httpClient.sendRequest<ApiResponse<PublishMenu200Response>>({
                path: '/deliveryProviderPortal/publishMenu',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public rePublishActiveMenuForProvider = async (body: RePublishActiveMenuForProviderRequest, opts?: TRequestOptions): Promise<ApiResponse<RePublishActiveMenuForProvider200Response>>  => {
            return this.httpClient.sendRequest<ApiResponse<RePublishActiveMenuForProvider200Response>>({
                path: '/deliveryProviderPortal/rePublishActiveMenuForProvider',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public removeMenuEntityImages = async (body: MenuEntityImageRequest, opts?: TRequestOptions): Promise<ApiResponse<MenuItemsBulkUpdate200Response>>  => {
            return this.httpClient.sendRequest<ApiResponse<MenuItemsBulkUpdate200Response>>({
                path: '/deliveryProviderPortal/removeMenuEntityImages',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public setDynamicFieldsValues = async (body: SetDynamicFieldsValuesRequest, opts?: TRequestOptions): Promise<ApiResponse<MenuItemsBulkUpdate200Response>>  => {
            return this.httpClient.sendRequest<ApiResponse<MenuItemsBulkUpdate200Response>>({
                path: '/deliveryProviderPortal/setDynamicFieldsValues',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public storeImprovementTrackEnrollmentAnalyticsEvent = async (body: StoreImprovementTrackAnalyticsEventRequest, opts?: TRequestOptions): Promise<ApiResponse<MenuItemsBulkUpdate200Response>>  => {
            return this.httpClient.sendRequest<ApiResponse<MenuItemsBulkUpdate200Response>>({
                path: '/deliveryProviderPortal/storeImprovementTrackEnrollmentAnalyticsEvent',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public trackDetailedReportsPageViewed = async (body: TrackDetailedReportsPageViewedRequest, opts?: TRequestOptions): Promise<ApiResponse<MenuItemsBulkUpdate200Response>>  => {
            return this.httpClient.sendRequest<ApiResponse<MenuItemsBulkUpdate200Response>>({
                path: '/deliveryProviderPortal/trackDetailedReportsPageViewed',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public updateMenuEntity = async (body: UpdateMenuEntityRequest, opts?: TRequestOptions): Promise<ApiResponse<UpdateMenuEntity200Response>>  => {
            return this.httpClient.sendRequest<ApiResponse<UpdateMenuEntity200Response>>({
                path: '/deliveryProviderPortal/updateMenuEntity',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public updateMenuEntityImage = async (body: UpdateMenuEntityImageMultipart, files: Record<'image', File>, opts?: TRequestOptions): Promise<ApiResponse<UpdateMenuEntityImage200Response>>  => {
            return this.httpClient.sendRequest<ApiResponse<UpdateMenuEntityImage200Response>>({
                path: '/deliveryProviderPortal/updateMenuEntityImage',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
                files,
            }, opts);
        }
        public updateMenuItemsDisplayOrder = async (body: UpdateMenuItemsDisplayOrderRequest, opts?: TRequestOptions): Promise<ApiResponse<MenuItemsBulkUpdate200Response>>  => {
            return this.httpClient.sendRequest<ApiResponse<MenuItemsBulkUpdate200Response>>({
                path: '/deliveryProviderPortal/updateMenuItemsDisplayOrder',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public updateProviderDetails = async (body: UpdateProviderDetailsRequest, opts?: TRequestOptions): Promise<ApiResponse<MenuItemsBulkUpdate200Response>>  => {
            return this.httpClient.sendRequest<ApiResponse<MenuItemsBulkUpdate200Response>>({
                path: '/deliveryProviderPortal/updateProviderDetails',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public updateProviderMenuTimetable = async (body: UpdateProviderMenuTimetableRequest, opts?: TRequestOptions): Promise<ApiResponse<MenuItemsBulkUpdate200Response>>  => {
            return this.httpClient.sendRequest<ApiResponse<MenuItemsBulkUpdate200Response>>({
                path: '/deliveryProviderPortal/updateProviderMenuTimetable',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public updateProviderOnboardingDetails = async (body: UpdateProviderOnboardingDetailsRequest, opts?: TRequestOptions): Promise<ApiResponse<MenuItemsBulkUpdate200Response>>  => {
            return this.httpClient.sendRequest<ApiResponse<MenuItemsBulkUpdate200Response>>({
                path: '/deliveryProviderPortal/updateProviderOnboardingDetails',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public updateProviderSchedule = async (body: UpdateProviderScheduleRequest, opts?: TRequestOptions): Promise<ApiResponse<MenuItemsBulkUpdate200Response>>  => {
            return this.httpClient.sendRequest<ApiResponse<MenuItemsBulkUpdate200Response>>({
                path: '/deliveryProviderPortal/updateProviderSchedule',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public uploadProviderAuthorizationDocument = async (body: UploadProviderAuthorizationDocumentMultipart, files: Record<'file', File>, opts?: TRequestOptions): Promise<ApiResponse<MenuItemsBulkUpdate200Response>>  => {
            return this.httpClient.sendRequest<ApiResponse<MenuItemsBulkUpdate200Response>>({
                path: '/deliveryProviderPortal/uploadProviderAuthorizationDocument',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
                files,
            }, opts);
        }
        public uploadProviderImage = async (body: UploadProviderImageMultipart, files: Record<'file', File>, opts?: TRequestOptions): Promise<ApiResponse<MenuItemsBulkUpdate200Response>>  => {
            return this.httpClient.sendRequest<ApiResponse<MenuItemsBulkUpdate200Response>>({
                path: '/deliveryProviderPortal/uploadProviderImage',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
                files,
            }, opts);
        }
}
// Split class actual prototype and type
export const ApiClient = ApiClientClass;
/**
 * When you use ApiClient class as a type it would include private / protected properties which leads
 * to a situation where 2 sources of the ApiClient are not equal.
 *
 * This situation can happen for example when a library depends on the whole ApiClient and consumer wants to pass
 * in its own ApiClient. That would lead to an error
 *
 * TS2345: Argument of type 'ApiClient<HttpClientConstraints, HttpRequestOpts>' is not assignable to parameter of type 'ApiClient<HttpClientConstraints, never>'.
 *  Property 'apiClientOptions' is protected but type 'GeneratedApiClient<THttpClientConstraints, TRequestOptions>' is not a class derived from 'GeneratedApiClient<THttpClientConstraints, TRequestOptions>'.
 */
export type ApiClient<THttpClientConstraints extends GeneratedHttpClientConstraints = HttpClientConstraints, TRequestOptions extends RequestOptionsConstraint = never> = {
    [Key in keyof ApiClientClass<THttpClientConstraints, TRequestOptions>]: ApiClientClass<THttpClientConstraints, TRequestOptions>[Key];
};